import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { presentationsCacheKey } from './usePresentations';

function useRenameLesson() {
  const queryClient = useQueryClient();

  const { mutate: renameLesson, isPending: isRenaming } = useMutation({
    mutationFn: async ({ lessonId, title }: { lessonId: string; title: string }) => {
      return BackendService.instance.template.templateAutoSave(
        {
          id: lessonId,
          title,
          modifiedAt: Date.now(),
        },
        undefined,
      );
    },
    onSuccess: () => {
      // Invalidate all presentations queries to refresh the list
      queryClient.invalidateQueries({
        queryKey: [presentationsCacheKey]
      });
    },
  });

  return {
    renameLesson,
    isRenaming,
  };
}

export default useRenameLesson;
